import React from 'react'
import { Typography } from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { SELECT_ROOM_CONDITION_STATE } from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import PropTypes from '@app/components/PropTypes'
import styles from './Room.style'

class Room extends React.Component {
  onRoomClick = (room) => {
    const {
      navigate,
      saveConditionDescription,
      saveConditionRoomNumber,
    } = this.props
    saveConditionDescription(room.name)
    saveConditionRoomNumber(room.number)
    navigate(SELECT_ROOM_CONDITION_STATE)
  }

  render() {
    const {
      classes,
      room,
    } = this.props
    return (
      <Wrapper
        className={classes.room}
        onClick={() => {
          this.onRoomClick(room)
        }}
      >
        <Typography className={classes.title} variant="h6" component="h2">
          {room.name}
        </Typography>
      </Wrapper>
    )
  }
}

Room.propTypes = {
  classes: PropTypes.object.isRequired,
  saveConditionDescription: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  saveConditionRoomNumber: PropTypes.func.isRequired,
  room: PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

Room.defaultProps = {

}

export default withStyles(Room, styles)
